import { LanguageOption } from '../types/language-option';
import {
  EditorCallbacks,
  ICodeEditorFactory,
} from '../interfaces/CodeEditorFactory';
import { CodeEditorBlockToolData } from '../types/data';
import { ControlBuilderFacade } from '../facades/control-builder-facade';
import SelectBuilderFacade from '../facades/select-builder-facade';
import { I18n } from '@editorjs/editorjs/types/api';

export default class CodeEditorBuilder {
  constructor(
    private readonly container: HTMLElement,
    private readonly i18n: I18n,
  ) {}

  private getControlsContainer() {
    return this.container.querySelector('#controls-container');
  }

  public getExecutionContainerId() {
    return 'executionContainer';
  }

  withCodeEditor(
    data: CodeEditorBlockToolData,
    factory: ICodeEditorFactory,
    callbacks?: EditorCallbacks,
  ) {
    const codeEditor = factory.createCodeEditorElement(data, callbacks);
    codeEditor.setAttribute('id', 'code-editor');
    this.container.append(codeEditor);

    return this;
  }

  withDivider() {
    const divider = document.createElement('hr');
    this.container.append(divider);
    return this;
  }

  withExecutionContainer(id: string) {
    const executionContainer = document.createElement('div');
    executionContainer.setAttribute('id', id);
    const controlsContainers = document.createElement('div');
    controlsContainers.setAttribute('id', 'controls-container');
    executionContainer.appendChild(controlsContainers);
    this.container.append(executionContainer);
    return this;
  }

  withLanguageSelect(
    selectedLanguage: string,
    languages: LanguageOption[],
    onChangeLanguage: (language: string) => void,
  ) {
    if (!languages.length) return this;
    const select = SelectBuilderFacade.create(
      languages,
      onChangeLanguage,
      selectedLanguage,
    );
    this.container.append(select);
    return this;
  }

  withCodeRunner(runCode?: () => void) {
    if (!runCode) return this;
    const controlsContainer = this.getControlsContainer();
    if (!controlsContainer) return this;
    controlsContainer.append(
      ControlBuilderFacade.buildRunCode(this.i18n, runCode),
    );
    return this;
  }

  withResetButton(resetCode: () => void) {
    const controlsContainer = this.getControlsContainer();
    if (!controlsContainer) return this;
    controlsContainer.append(
      ControlBuilderFacade.buildResetButton(this.i18n, resetCode),
    );
    return this;
  }

  build(): HTMLElement {
    return this.container;
  }
}
